"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var interface_geo_1 = require("@uip-alpha/interface-geo");
/**
 * 根据详细地址获取地址经纬度等相关参数
 * @param params 地址详细信息
 */
var getAddressInfo = function (UIP) { return function (params, switch2Bd09) {
    if (switch2Bd09 === void 0) { switch2Bd09 = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var addressInfo, _a, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!params.address)
                        return [2 /*return*/, {}];
                    _a = Object;
                    return [4 /*yield*/, UIP.interface.geo.gis.GEO(params)];
                case 1:
                    addressInfo = _a.apply(void 0, [_b.sent()]);
                    // 是否转换为BD-09百度坐标系
                    if (switch2Bd09) {
                        if (isLngLatValid(addressInfo.lng, addressInfo.lat)) {
                            data = UIP.interface.geo.utils.GCJ022BD09({ longitude: addressInfo.lng, latitude: addressInfo.lat });
                            addressInfo.lng = data.longitude;
                            addressInfo.lat = data.latitude;
                        }
                    }
                    return [2 /*return*/, addressInfo];
            }
        });
    });
}; };
/**
 * 根据输入地址进行地址联想
 * @param params 地址联想参数
 */
var getAssAddress = function (UIP) { return function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var addData, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!params.q)
                    return [2 /*return*/, {}];
                _a = Object;
                return [4 /*yield*/, UIP.interface.geo.gis.TIP(params)];
            case 1:
                addData = _a.apply(void 0, [_b.sent()]);
                return [2 /*return*/, {
                        sn: addData.sn || '',
                        address: addData.POISet || []
                    }];
        }
    });
}); }; };
/**
 * 通过经纬度获取附近地址
 * @param point 经纬度对象{lng, lat}
 * @param pointNum 获取附近地址的数量
 */
var getNearbyPosition = function (UIP) { return function (point, pointNum) {
    if (pointNum === void 0) { pointNum = 10; }
    return __awaiter(void 0, void 0, void 0, function () {
        var pointData, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = Object;
                    return [4 /*yield*/, UIP.interface.geo.gis.RGEO({
                            x: point.lng,
                            y: point.lat,
                            poinum: pointNum
                        })];
                case 1:
                    pointData = _a.apply(void 0, [_b.sent()]);
                    if (pointData.pois)
                        return [2 /*return*/, pointData.pois];
                    return [2 /*return*/, []];
            }
        });
    });
}; };
/**
 * 查看经纬度是否有效
 * @param lng 经度
 * @param lat 纬度
 */
var isLngLatValid = function (lng, lat) {
    if (Number(lng) && Number(lat))
        return true;
    return false;
};
/**
 * 通过经纬度获取规划路径
 * @param oriLng 起始点经度
 * @param oriLat 起始点纬度
 * @param dstLng 终点经度
 * @param dstLat 终点纬度
 * @param cc 坐标系 1-高德腾讯坐标系 2-百度坐标系
 */
var getRssPointsByLngLat = function (UIP) { return function (oriLng, oriLat, dstLng, dstLat, cc) {
    if (cc === void 0) { cc = 1; }
    return __awaiter(void 0, void 0, void 0, function () {
        var res, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isLngLatValid(oriLng, oriLat) || !isLngLatValid(dstLng, dstLat))
                        return [2 /*return*/, []];
                    _a = Object;
                    return [4 /*yield*/, UIP.interface.geo.gis.RSS({
                            x1: oriLng,
                            y1: oriLat,
                            x2: dstLng,
                            y2: dstLat,
                            cc: cc
                        })];
                case 1:
                    res = _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/, res.coords || []];
            }
        });
    });
}; };
/**
 * 通过详细地址获取规划路径
 * @param originAddress 起始点地址
 * @param destinationAddress 终点地址
 * @param cc 坐标系 1-高德腾讯坐标系 2-百度坐标系
 */
var getRssPointsByAddress = function (UIP) { return function (originAddress, destinationAddress, cc) {
    if (cc === void 0) { cc = 1; }
    return __awaiter(void 0, void 0, void 0, function () {
        var res, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = Object;
                    return [4 /*yield*/, UIP.interface.geo.gis.RSS({
                            origin: originAddress,
                            destination: destinationAddress,
                            cc: cc
                        })];
                case 1:
                    res = _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/, res.coords || []];
            }
        });
    });
}; };
exports.default = (function (config) { return function (UIP) {
    UIP.use(interface_geo_1.GIS(config));
    UIP.use(interface_geo_1.utils);
    UIP.checkModule('business', 'gis');
    UIP.business.gis = {
        getAddressInfo: getAddressInfo(UIP),
        getAssAddress: getAssAddress(UIP),
        getNearbyPosition: getNearbyPosition(UIP),
        getRssPointsByAddress: getRssPointsByAddress(UIP),
        getRssPointsByLngLat: getRssPointsByLngLat(UIP)
    };
}; });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/business-gis/dist/index.js
// module id = Dr8M
// module chunks = 1